import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/systems/logs/accesslog',
  title: 'Access log',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);